export default __webpack_public_path__ + "static/media/partnership-brand.b2f5bf93.png";